import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { MaintenanceMessageModel } from "../models/maintenanceMessage.model";

@Injectable({
    providedIn: 'root'
  })
  export class MaintenanceMessageService {
    __URL_API__  = `${environment.URL_API}`; 

    constructor(private _http: HttpClient) {
    }

    async getMaintenanceMessage(): Promise<MaintenanceMessageModel> {
        try {
          let response = await this._http.get(this.__URL_API__ + 'api/MaintenanceMessages/ecli').toPromise();
          return response as MaintenanceMessageModel;
            } catch (error) {
                return await this.handleError(error);
                }
      }
      private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }
}